import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateLearnerQuestionRes;
export const addUpdateLearnerQuestionTodo = createAsyncThunk('addUpdateLearnerQuestion', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/add_update_ask_question',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "fk_ask_id": data.fk_ask_id,
                "course_id": data.course_id,
                "title": data.title,
                "description": data.description,
                "answer": data.answer,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateLearnerQuestionRes = res.data
    } catch (error) {
        return addUpdateLearnerQuestionRes = error.response.data
    }
})